import { render, staticRenderFns } from "./FloatingBottomContainer.vue?vue&type=template&id=464be2e9&"
import script from "./FloatingBottomContainer.vue?vue&type=script&lang=ts&"
export * from "./FloatingBottomContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingBottomContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports